import { render, staticRenderFns } from "./Tagreader.vue?vue&type=template&id=0fda1be3&"
import script from "./Tagreader.vue?vue&type=script&lang=js&"
export * from "./Tagreader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports